// @flow
import React, {Component, Fragment} from 'react';
import Modal from '../../../../../elements/Modal/Modal';
import {FormValidator} from '../../../../../utils/form';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {sendQuoteMailApi} from '../../api';

import type {FormValidationResult} from '../../../../../utils/form';

import inputStyle from '../../../../../assets/styles/input.scss';
import formStyle from '../../../../../assets/styles/form.scss';
import buttonStyle from "../../../../../assets/styles/button.scss";

type Props = {
  url: string;
};

type State = {
  email: {
    value: string;
    errors?: string[];
  };
  sent: boolean;
  loadingManualQuote: boolean;
};

const titleStyle = {
  color: 'black',
  fontSize: '24px',
  lineHeight: '24px',
  textAlign: 'center',
};

const contentStyle = {
  color: '#757575',
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
}

export default class ManualQuoteModal extends Component<Props, State> {
  formValidator: FormValidator;

  constructor(props: Props) {
    super(props);
    this.state = {
      email: {
        value: '',
      },
      sent: false,
      loadingManualQuote: false,
    };
    
    this.formValidator = new FormValidator({
      email: {
        required: 'required',
        emailFormat: 'emailFormat',
      },
    });
  }

  handleChange(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  }

  handleFocus(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  }

  handleBlur(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      const errors = this.formValidator.validateField(name, value);
      if (errors.length && (errors[0] === 'emailFormat')) {
        this.setState({ [name]: { value, errors } });
      } else {
        this.setState({ [name]: { value } });
      }
    }
  }

  handleSubmit(e: Event) {
    e.preventDefault();
    const { url } = this.props;
    const emailValue = this.state.email.value;
    const errors = this.formValidator.validateForm({
      email: emailValue,
    });
    if (errors.length) {
      errors.forEach((error: FormValidationResult) => {
        this.setState({
          [error.field]: {
            ...this.state[error.field],
            errors: error.errors,
          },
        });
      });
    } else {
      this.sendMailApi(emailValue, url);
    }
  }
  
  sendMailApi(email: string, url: string) {
    this.setState({loadingManualQuote: true});
    
    sendQuoteMailApi({
      email,
      url,
    })
      .toPromise()
      .then(() => {
        this.setState({
          loadingManualQuote: false,
          sent: true,
        });
      })
      .catch(() => {
        this.setState({
          loadingManualQuote: false,
          sent: true,
        });
      });
  }
  
  render() {
    const {email, sent, loadingManualQuote} = this.state;

    const emailError = email.errors && FormValidator.buildErrorLabel(email.errors, {
      emailFormat: 'auth.email.error.format',
      required: 'auth.email.error.required',
    });
    
    const inputContent = (
      <Fragment>
        <h3 style={titleStyle}>¡Gracias por visitar Qempo!</h3>
        <p style={contentStyle}>
          Estamos reestructurando nuestra plataforma, pero no te preocupes: podemos ayudarte ahora mismo con tu pedido.
          Déjanos tu correo electrónico y atenderemos tu solicitud de inmediato.
        </p>
        <br/>
        <form className={classNames(formStyle.formWrap)}
              onSubmit={this.handleSubmit.bind(this)}>
          <section className={classNames(formStyle.row, formStyle.inputRow)}>
            <FormattedMessage id="auth.email.label">{
              txt => (<label className={formStyle.label}>{txt}</label>)
            }</FormattedMessage>
            <input type="email"
                   className={classNames(inputStyle.input,
                     { [inputStyle.red]: email.errors && email.errors.length },
                     { [inputStyle.lightBlue]: !!email.value })}
                   onChange={this.handleChange.bind(this)}
                   onFocus={this.handleFocus.bind(this)}
                   onBlur={this.handleBlur.bind(this)}
                   disabled={loadingManualQuote}
                   name="email" />
            {emailError}
          </section>
          <br/>
          <button
            type="submit"
            disabled={loadingManualQuote}
            className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
            onClick={this.handleSubmit.bind(this)}>
            Enviar Solicitud
          </button>
        </form>
      </Fragment>
    );
    
    const sentContent = (
      <Fragment>
        <h3 style={titleStyle}>¡Hemos recibido tu solicitud!</h3>
        <p style={contentStyle}>
          Muchas gracias. La verificaremos a la brevedad posible.
          ¡Manténte atento a tu correo electrónico!
        </p>
        <br/>
        <button
          type="button"
          style={{width: '100%'}}
          className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
          onClick={() => {
            if (window) {
              window.document.location.href = '/';
            }
          }}>
          Cerrar
        </button>
      </Fragment>
    );
    
    return (
      <Modal handleClose={() => {}}
             open={true}
             maskColor="black"
             showCloseButton={false}
             big>
        <div style={{textAlign: 'center'}}>
          {!sent ? inputContent : sentContent}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/ManualQuoteModal/ManualQuoteModal.jsx